export default __webpack_public_path__ + "static/media/logo.a10b0daf.svg";